module.exports = __webpack_public_path__ + "static/img/new_eight.a203c2b3.jpg";